<!--车型分类管理-->
<template>
  <div class="mod-rm__vehicleclass">
    <div :style="{'height': cardHeight+'px'}" class="box-card">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-card :style="{'height': cardHeight+'px'}" ref="vehicleClassRef">
            <el-button size="small" type="text" @click="openTree()">{{ $t('res.classroom.unFold') }}</el-button>
            <el-button size="small" type="text" @click.native="closeTree()">{{ $t('res.classroom.fold') }}</el-button>
            <span>{{ $t('res.classroom.see') }}：</span>
            <el-checkbox v-model="statusChecked" @change="changeActivity">{{ $t('res.classroom.activity') }}</el-checkbox>
            <el-checkbox v-model="checked" @change="changeNoActivity">{{ $t('res.vehinfo.unInactive') }}</el-checkbox>
            <el-tree
              class="filter-tree"
              :data="dataList"
              default-expand-all
              highlight-current
              ref="vehicleClassTreeRef"
              node-key="id"
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              :filter-node-method="filterNode"
              :props="defaultProps"
            >
            <span class="menu-tree-node" slot-scope="scope">
              <span>{{scope.node.label}}</span>
              <span>
                <!--新增-->
                <em class="el-icon-plus ipl" v-show="scope.data.lv === 1 ||scope.data.lv === 2 || scope.data.lv === 3"  @click.stop="append(scope.data)"></em>
                <!--修改-->
                <em class="el-icon-edit ipl" @click.stop="edit(scope.data)"></em>
                <!--删除scope.data.children.length === 0-->
                <em class="el-icon-delete ipl" v-if="scope.data.lv != 1" @click.stop="deleteSiteClass(scope.data)"></em>
              </span>
            </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="14">
          <el-card :style="{'height': cardHeight+'px'}" ref="resourceRef">
            <h3>{{ $t('res.classroom.baseInfo') }}</h3>
            <br>
            <div v-show="isShowBaseInfo">
              <el-form :inline="true"
                       :model="editForm" :rules="editRule" ref="eidtForm" label-position="right" :disabled="checkEdit">
                <el-row>
                  <el-col class="mar-b">
                    <!--上级节点名称-->
                    <el-form-item :label="$t('res.classroom.pName')" label-width="125px">
                      <el-input disabled v-model="editForm.pName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="mar-b">
                    <!--分类状态-->
                    <el-form-item :label="$t('res.classroom.state')" prop="classStatus" label-width="125px">
                      <el-select v-model="editForm.classStatus"
                                 >
                        <el-option v-for="(item,index) in roomClassList"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="mar-b">
                    <!--分类名称-->
                    <el-form-item :label="$t('res.classroom.name')" prop="classCnName" label-width="125px">
                      <el-input v-model="editForm.classCnName"
                                maxlength="20"
                                clearable></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <!--保存按钮-->
                  <div style="margin: 10px 0px 20px 127px;">
                    <el-button type="primary" v-if="!checkEdit" :loading="dataListLoading"
                               @click.native="saveSiteClass()">{{ $t('region.save') }}</el-button>
                  </div>
                </el-row>
              </el-form>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { treeDataTranslate } from '../../../utils'
export default {
  mixins: [mixinViewModule],
  data () {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/rm/vehicleclass/list',
        getDataListIsPage: true,
        deleteURL: '/rm/vehicleclass/delete',
        deleteIsBatch: true,
        exportURL: '/rm/vehicleclass/export'
      },
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      roomClassList: _this.enums['status'], // 状态下拉框
      defaultProps: {
        children: 'children',
        label: 'classCnName'
      },
      // 编辑
      editForm: {
        pName: '',
        classStatus: '',
        classCnName: ''
      },
      // 是否显示基本信息
      isShowBaseInfo: true,
      editRule: {
        classStatus: [
          { required: true, message: this.$t('res.classroom.state') + this.$t('res.site.notNull'), trigger: 'change' }
        ],
        classCnName: [
          { required: true, message: this.$t('res.classroom.name') + this.$t('res.site.notNull'), trigger: 'blur' }
        ]
      },
      vehicleClassRow: undefined,
      isAdd: undefined,
      statusChecked: true,
      checked: false,
      // 查看时不可编辑
      checkEdit: true,
      // 默认活动
      filterText: '10',
      // card的高度
      cardHeight: undefined
    }
  },
  components: {},
  activated () {
    this.getDataList()
  },
  watch: {
    // 搜索
    filterText (val) {
      this.$refs.vehicleClassTreeRef.filter(val)
    }
  },
  methods: {
    // 鼠标左键点击获取每个treelist值的详细信息
    handleNodeClick (data, node, templateNode) {
      this.isShowBaseInfo = true
      this.editForm.classStatus = data.classStatus
      this.editForm.classCnName = data.classCnName
      this.editForm.pName = data.pName
      this.checkEdit = true
      this.$nextTick(() => {
        this.$refs.eidtForm.clearValidate()
      })
    },
    // 展开
    openTree () {
      let _this = this
      this.$nextTick(() => {
        for (let i = 0; i < _this.$refs.vehicleClassTreeRef.store._getAllNodes().length; i++) {
          _this.$refs.vehicleClassTreeRef.store._getAllNodes()[i].expanded = true
        }
      })
    },
    // 收起
    closeTree () {
      let _this = this
      this.$nextTick(() => {
        for (let i = 0; i < _this.$refs.vehicleClassTreeRef.store._getAllNodes().length; i++) {
          _this.$refs.vehicleClassTreeRef.store._getAllNodes()[i].expanded = false
        }
      })
    },
    // 筛选
    filterNode (value, data) {
      if (!value) return true
      return data.classStatus.indexOf(value) !== -1
    },
    changeActivity (val) {
      if ((this.statusChecked === this.checked) && (this.statusChecked === false)) {
        this.statusChecked = true
      }
      if (this.statusChecked && this.checked) {
        this.filterText = ''
      } else {
        if (this.statusChecked) {
          this.filterText = '10'
        } else {
          this.filterText = '20'
        }
      }
    },
    changeNoActivity (val) {
      if ((this.statusChecked === this.checked) && (this.checked === false)) {
        this.checked = true
      }
      if (this.statusChecked && this.checked) {
        this.filterText = ''
      } else {
        if (this.checked) {
          this.filterText = '20'
        } else {
          this.filterText = '10'
        }
      }
    },
    // 添加
    append (data) {
      this.isShowBaseInfo = true
      this.editForm.classStatus = '10'
      this.editForm.pName = data.classCnName
      this.editForm.classCnName = ''
      this.vehicleClassRow = data
      this.isAdd = true
      this.checkEdit = false
      this.$nextTick(() => {
        this.$refs.eidtForm.clearValidate()
      })
    },
    // 删除
    deleteSiteClass (data) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        let _this = this
        let url = ''
        let param = ''
        url = '/rm/vehicleclass/delete'
        param = {
          'id': data.id
        }
        _this.$request.post(
          url, param
        ).then((data) => {
          _this.$message({
            message: _this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getDataList()
              this.isShowBaseInfo = true
              this.checkEdit = true
              // 清空表单的数据
              this.editForm.pName = ''
              this.$refs.eidtForm && this.$refs.eidtForm.resetFields()
            }
          })
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 编辑
    edit (data) {
      this.isShowBaseInfo = true
      Object.assign(this.editForm, data)
      this.vehicleClassRow = data
      this.isAdd = false
      this.checkEdit = false
      this.$nextTick(() => {
        this.$refs.eidtForm.clearValidate()
      })
    },
    // 保存
    saveSiteClass () {
      let _this = this
      _this.$refs['eidtForm'].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('prompt.info', { 'handle': this.$t('res.vehinfo.save') }), this.$t('prompt.title'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            let url = ''
            let param = ''
            if (!_this.isAdd) {
              url = '/rm/vehicleclass/update'
              // 修改
              param = {
                'id': _this.vehicleClassRow.id,
                'classStatus': _this.editForm.classStatus,
                'classCnName': _this.editForm.classCnName,
                'levelPid': _this.editForm.levelPid,
                'version': _this.vehicleClassRow.version
              }
            } else {
              // 新增
              url = '/rm/vehicleclass/save'
              param = {
                'classStatus': _this.editForm.classStatus,
                'classCnName': _this.editForm.classCnName,
                'vehicleClassEnName': _this.editForm.classCnName,
                'lv': _this.vehicleClassRow.lv + 1,
                'levelPid': _this.vehicleClassRow.id
              }
            }
            this.dataListLoading = true
            _this.$request.post(
              url, param
            ).then((data) => {
              _this.$message({
                message: _this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.getDataList()
                  this.isShowBaseInfo = true
                  this.checkEdit = true
                }
              })
            }).catch(() => {
              this.dataListLoading = false
            })
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    },
    // 获取数据列表
    getDataList () {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        let resultList = data.result
        this.dataList = resultList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.total : 0
        this.$nextTick(() => {
          this.$refs.vehicleClassTreeRef.filter(this.filterText)
        })
      }).catch(() => {
        this.dataListLoading = false
      })
    }
  },
  // 获取每个子节点的信息
  mounted () {
    let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    this.cardHeight = winHeight
    this.$request.get(`/rm/vehicleclass/list`).then((res, total, code, data) => {
      this.data = treeDataTranslate(data.result, 'id', 'levelPid')
    }).catch((err) => {
      console.log(err)
    })
  }
}
</script>
<style type="text/css" scoped>

  /*tree树的整体样式*/
  .menu-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  /*新增修改删除按钮的样式*/
  .ipl{margin-left: 15px; padding: 2px; border: 1px #ffffff solid}
  .ipl:hover{background-color: #fff; color: #1C69D3; border: 1px #1C69D3 solid}

  /*右边文本框的下边距样式 */
  .mar-b {
    margin-bottom: 10px;
  }
  /*大卡片的样式*/
  .box-card {
    -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);

    border: 1px solid #ebeef5;
    background-color: #fff;
    color: #303133;
    -webkit-transition: .3s;
    transition: .3s;

    border-radius: 4px;
    overflow: hidden;
    padding: 0 0 0 0;
  }
</style>
